import { initialSharedState } from '@features/_shared/store/state';
import { IReduxConfig, ReduceableReducer } from '@hypereact/state';
import { Slices } from './state';

export const reduxConfig: IReduxConfig = {
    [Slices.Shared]: new ReduceableReducer(initialSharedState),
};
